import { render } from "./Awards.vue?vue&type=template&id=137b4700&scoped=true"
import script from "./Awards.vue?vue&type=script&lang=js"
export * from "./Awards.vue?vue&type=script&lang=js"

import "./Awards.vue?vue&type=style&index=0&id=137b4700&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137b4700"]])

export default __exports__